import React from 'react';
import {Container} from './styled';

const News: React.FC = () => {
    return (
        <Container>
            <span>Assuntos do momento no Brasil</span>
            <strong>BootCamp Rocket</strong>
        </Container>
    );
}

export default News;